<script>
export default {
  name: "MobileMappingContact",
  data: () => ({
    contactImage: require("@/assets/mobile-mapping-quote-headshot.png")
  })
};
</script>

<template>
  <div>
    <div class="h2 mb-5 new-font-medium">Ihre Ansprechperson</div>
    <v-sheet class="mobile-mapping-contact-box">
      <img :src="contactImage" width="72px" height="72px" />
      <div style="margin-left: 24px">
        <div class="contact-name">Thorsten Jansen</div>
        <div class="contact-title">Referent NEW Netz</div>
        <div
          style="display: flex; flex-direction: column; align-items: flex-start;"
          class="mt-2"
        >
          <span class="contact-way-label">
            <a href="mailto:thorsten.jansen@new-netz.de"
              >Thorsten.Jansen@new-netz.de</a
            >
          </span>
          <span class="contact-way-label mt-2">
            <a href="tel:+4924516245233">+4924516245233</a>
          </span>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<style scoped>
.mobile-mapping-contact-box {
  width: fit-content;
  padding: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 80px;
  border-radius: 5px;
}

.contact-name {
  font-size: 16px;
  font-family: "GeometriaMedium", sans-serif;
}

.contact-title {
  font-size: 14px;
}

.contact-way-label {
  padding: 4px;
  font-size: 14px;
  color: #b40055;
  background: #f8e6ee;
  border-radius: 5px;
  line-height: 24px;
}
</style>
